import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { Link } from 'react-router';

import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';

const forgotPasswordSchema = z.object({
  email: z.string().trim().min(1, 'Enter your email address to continue').email('Email address is invalid'),
});

export type IForgotPasswordForm = z.infer<typeof forgotPasswordSchema>;

type Props = {
  onSubmit: (data: IForgotPasswordForm) => Promise<void>;
};

const ForgotPasswordForm = ({ onSubmit }: Props) => {
  const form = useForm<IForgotPasswordForm>({
    resolver: zodResolver(forgotPasswordSchema),
    defaultValues: {
      email: '',
    },
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Email address</FormLabel>
              <FormControl>
                <Input {...field} type="email" placeholder="you@company.com" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <div className="flex mt-2 gap-2">
          <Button variant="outline" size="lg" asChild className="flex-1">
            <Link to="/login">Back to sign in</Link>
          </Button>
          <Button
            type="submit"
            size="lg"
            className="flex-1"
            isLoading={form.formState.isSubmitting}
            disabled={form.formState.isSubmitting}
          >
            Send reset code
          </Button>
        </div>
      </form>
    </Form>
  );
};

export default ForgotPasswordForm;
